module.exports = __webpack_public_path__ + "static/media/logo.38bd32a0.png";